module.exports = __webpack_public_path__ + "img/publipostage-actif.a1469f13.svg";